'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/DownloadSimple.js";
var p = Object.defineProperty, l = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var a = (e, o, m) => o in e ? p(e, o, { enumerable: true, configurable: true, writable: true, value: m }) : e[o] = m, t = (e, o) => {
  for (var m in o || (o = {}))
    n.call(o, m) && a(e, m, o[m]);
  if (r)
    for (var m of r(o))
      s.call(o, m) && a(e, m, o[m]);
  return e;
}, i = (e, o) => l(e, f(o));
const I = forwardRef((e, o) => /* @__PURE__ */ a__default.createElement(b, i(t({ ref: o }, e), { weights: t$1 })));
I.displayName = "DownloadSimple";
export {
  I as DownloadSimple
};
